import * as React from 'react'
import type { SVGProps } from 'react'
const SvgCoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.4 1.28841C5.00188 0.795656 5.77136 0.5 6.60991 0.5C8.53788 0.5 10.1008 2.06293 10.1008 3.99091C10.1008 4.82907 9.80543 5.59824 9.31307 6.2M7.48182 6.60909C7.48182 8.53707 5.91888 10.1 3.99091 10.1C2.06293 10.1 0.5 8.53707 0.5 6.60909C0.5 4.68111 2.06293 3.11818 3.99091 3.11818C5.91888 3.11818 7.48182 4.68111 7.48182 6.60909Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgCoin
